import { Component, OnInit, ViewChild } from '@angular/core';
import { Category, ClientDTO, TTMap, SearchByOptions, StatesData } from 'src/store/workspace/workspace.model';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from 'src/store';
import * as fromWorkspace from 'src/store/workspace';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GridComponent, PagerSettings, PageChangeEvent } from '@progress/kendo-angular-grid';
import { isNumber, cloneDeep } from 'lodash';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { KendoButtonService } from '@progress/kendo-angular-buttons';
import { contains } from 'jquery';
import * as _ from 'lodash';

@Component({
  selector: 'app-clients',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss'],
})
export class ClientComponent implements OnInit {
  gridData$: Observable < [ClientDTO[], number | 'all', SearchByOptions] > ;
  gridData: ClientDTO[];
  gridSubs: Subscription;
  targetClient: ClientDTO;
  deleteOpened: boolean;
  updateOpened: boolean;
  newOpened: boolean;
  clients$: Observable < TTMap < ClientDTO >> ;
  clientsMap: TTMap < ClientDTO > ;
  clientsSubs: Subscription;
  clients: ClientDTO[];
  allClients: ClientDTO[];
  states: string[];
  originalStates: string[];

  formGroup: FormGroup;

  public pageSize: number | 'all' = 'all';
  public skip = 0;
  public length: number;
  public pageable: PagerSettings = {
    pageSizes: true,
    previousNext: true,
    info: true
  };
  public pageSizes: any[] = [10, 20, 30, 40, 50, {
    text: 'All',
    value: 'all'
  }];

  public sort: SortDescriptor[];
  public sortable = {
    allowUnsort: true,
    mode: 'single'
  };

  @ViewChild('grid', {
    static: false
  }) grid: GridComponent;

  public columns: any[] = [{
    field: 'clientID',
    hidden: true
  },
  {
    field: 'clientName',
    title: 'Client Name',
  },
  {
    field: 'invoiceName',
    title: 'Invoice Name'
  },
  {
    field: 'address',
    title: 'Address'
  },
  {
    field: 'city',
    title: 'City'
  },
  {
    field: 'state',
    title: 'State'
  },
  {
    field: 'zip',
    title: 'Zip'
  },
  {
    field: 'billTo',
    title: 'Bill To'
  },
  {
    field: 'emailAddress',
    title: 'Email Address'
  }];

  constructor(private store: Store < fromRoot.AppState > , private formBuilder: FormBuilder) {
    this.store.dispatch(new fromWorkspace.LoadClients());
    this.store.dispatch(new fromWorkspace.LoadClientsPageSize());
    this.sort = [];
    this.gridData$ = combineLatest(
      this.store.select(state => Object.values(state.workspace.clients)),
      this.store.select(state => state.workspace.clientsPageSize),
      this.store.select(state => state.workspace.searchByOptions)
    );
    this.clients$ = this.store.select(state => state.workspace.clients);
    this.clientsSubs = this.clients$.subscribe(clients => {
      this.clientsMap = clients;
      this.clients = Object.values(clients).sort((a, b) => {
        if (a.clientName.toLowerCase() > b.clientName.toLowerCase()) {
          return 1;
        }
        if (a.clientName.toLowerCase() < b.clientName.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    });
    this.gridSubs = this.gridData$.subscribe(([clients, pageSize, searchByOptions]) => {
      if (searchByOptions.client && searchByOptions.client.clientID) {
        clients = clients.filter(c => c.clientID === searchByOptions.client.clientID);
      }
      clients = clients.map(c => {
        const client = cloneDeep(c);
        client.clientName = this.clientsMap[client.clientID].clientName;
        return client;
      });
      clients = orderBy(clients, this.sort);
      this.length = clients.length;
      this.pageSize = pageSize;
      if (!isNumber(pageSize) && this.length) {
        this.pageSize = this.length || 10;
      }
      this.allClients = clients;
      const size = this.pageSize as number;
      this.gridData = clients.slice(this.skip, this.skip + size);
    });
    this.store.dispatch(new fromWorkspace.LoadClientsPageSize());
    this.store.select(state => state.workspace.clientsPageSize).subscribe(size => {
      this.pageSize = size;
    });

    this.states = StatesData;
    this.originalStates = StatesData;
  }

  ngOnInit() {}

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.store.dispatch(new fromWorkspace.LoadClients());
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    let pageSize: number | 'all' = event.take;
    if (pageSize === this.length) {
      pageSize = 'all';
    }

    this.store.dispatch(new fromWorkspace.SetClientsPageSize(pageSize));
    this.store.dispatch(new fromWorkspace.LoadClients());
    this.store.select(state => state.workspace.clientsPageSize);
  }

  public addClient(): void {
    const dataItem: ClientDTO = {
      clientID: 0,
      clientName: "",
      invoiceName: "",
      reportName: "",
      emailSubjectName: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      billTo: "",
      categorizeBilling: true,
      active: true,
      emailAddress: "",
    };
    this.targetClient = dataItem;
    this.newOpened = true;
  }

  public deleteClient(dataItem): void {
    this.targetClient = dataItem;
    this.deleteOpened = true;
  }

  public updateClient(dataItem): void {
    this.targetClient = dataItem;
    this.updateOpened = true;
  }

  public delete(dataItem: ClientDTO) {
    this.deleteOpened = false;
    this.store.dispatch(new fromWorkspace.DeleteClient(dataItem));
    this.targetClient = null;
  }

  public add(dataItem: ClientDTO) {
    this.newOpened = false;
    this.store.dispatch(new fromWorkspace.AddClient(dataItem));
    this.targetClient = null;
  }

  public update(dataItem: ClientDTO){
    this.updateOpened = false;
    this.store.dispatch(new fromWorkspace.UpdateClient(dataItem));
    this.targetClient = null;
  }

  public cancel(){
    this.targetClient = null;
    this.deleteOpened = false;
    this.newOpened = false;
    this.updateOpened = false;
  }

  public handleFilter(v: string){
    const states: string[] = [];

    _.each(this.originalStates, (s: string) => {
      if (s.toLowerCase().indexOf(v.toLowerCase()) !== -1) {
        states.push(s);
      }
    });

    this.states = states;
  }

  public stateSelected(s: string){
    this.targetClient.state = s;
  }

}
